import Powerbook from './powerbook2/Powerbook';
import { isNotDefined, namespace } from '../utils/util';

(function ($) {
  "use strict";

  namespace('nc.lineage');

  nc.lineage.searchPowerbook = function (options) {
    if (isNotDefined(options)) throw new Error('nc.lineage.searchPowerbook require options object');

    return new Powerbook(options).init();
  };
}(jQuery));


// WEBPACK FOOTER //
// ./_src/js/search/search-powerbook.3.js